import { insertartBitacoraCliente } from "../clientes/thunkClientes";
import { actualizarAgendaApi, crearNuevaAgenda, extraerEventoIdApi, traerEventosTodosPersonalApi, traerEventosTodosVendedores } from "./Api_Clientes_Providers";

/**
 * @description Thunk para obtener eventos de agenda de vendedores según criterios específicos.
 * Esta función utiliza Redux Thunk para ejecutar una acción asíncrona que obtiene eventos
 * de agenda filtrados por estado y rango de fechas, utilizando el ID del administrador
 * almacenado en el estado de autenticación.
 *
 * @param {string} estado_agenda - Estado de los eventos a consultar ('pendiente', 'completado', 'cancelado')
 * @param {string} fecha_inicio - Fecha de inicio del rango para filtrar (formato YYYY-MM-DD)
 * @param {string} fecha_fin - Fecha de fin del rango para filtrar (formato YYYY-MM-DD)
 *
 * @returns {Function} Función thunk que retorna una Promesa con los eventos de agenda filtrados
 *
 * @example
 * // Ejemplo de uso en un componente
 * dispatch(extraerAgenda('pendiente', '2025-06-01', '2025-06-30'))
 *   .then(eventos => {
 *     // Procesar los eventos obtenidos
 *     console.log(eventos);
 *   });
 */
export const extraerAgenda = (estado_agenda, fecha_inicio, fecha_fin) => {
    // Retorna una función thunk (patrón de Redux Thunk para acciones asíncronas)
    return async (dispatch, getState) => {
        // Obtiene el ID del administrador desde el estado de autenticación
        const { id_admin } = getState().auth;

        try {
            // Llama al proveedor de API para obtener los eventos de agenda según los criterios especificados
            const resultado = await traerEventosTodosVendedores({
                estado_agenda,
                fecha_inicio,
                fecha_fin,
                id_admin_agenda: id_admin,
            });

            // Retorna los datos de eventos de agenda obtenidos
            return resultado;
        } catch (error) {
            // Captura y registra cualquier error durante la obtención de datos
            console.error("Error al obtener eventos de agenda:", error);
            // Se podría mejorar este manejo de errores lanzando una excepción o devolviendo un objeto de error
            return {
                error: true,
                mensaje:
                    error.message || "Error desconocido al obtener eventos de agenda",
            };
        }
    };
};

/**
 * @description Thunk para crear un nuevo evento en la agenda.
 * Esta función utiliza Redux Thunk para ejecutar una acción asíncrona que crea un nuevo evento
 * de agenda, utilizando el ID del administrador almacenado en el estado de autenticación.
 *
 * @param {Object} formData - Datos del formulario con la información del nuevo evento de agenda
 * @returns {Function} Función thunk que retorna una Promesa con el resultado de la creación
 *
 * @example
 * // Ejemplo de uso en un componente
 * dispatch(crearAgenda({
 *   titulo: 'Reunión con cliente',
 *   fecha: '2025-06-15',
 *   hora: '14:30',
 *   descripcion: 'Presentación de propuesta',
 *   id_cliente: 123
 * }))
 * .then(resultado => {
 *   if (!resultado.error) {
 *     console.log('Evento creado exitosamente');
 *   } else {
 *     console.error(resultado.mensaje);
 *   }
 * });
 */
export const crearAgenda = (formData) => {
    // Retorna una función thunk (patrón de Redux Thunk para acciones asíncronas)
    return async (dispatch, getState) => {
        // Obtiene el ID del administrador desde el estado de autenticación
        const { id_admin } = getState().auth;

        try {
            // Llama al proveedor de API para crear un nuevo evento en la agenda
            const resultado = await crearNuevaAgenda({
                formData,
                id_admin_agenda: id_admin,
            });

            // Verificar si id_cliente no está vacío antes de ejecutar la inserción en bitácora
            if (formData.id_cliente && formData.id_cliente !== "") {
                await dispatch(
                    insertartBitacoraCliente({
                        bitacora_cliente: formData.id_cliente,
                        bitacora_nombreCliente: "Evento de agenda creado",
                        bitacora_detalle: `Se ha generado un evento "${formData.nombre_agenda}" para las fechas ${formData.fecha_inicio_agenda} a ${formData.fecha_fin_agenda} en horario de ${formData.hora_inicio_agenda} a ${formData.hora_fin_agenda} de tipo ${formData.tipo_agenda}`,
                    }),
                );
            }

            // Retorna el resultado de la creación del evento
            return resultado;
        } catch (error) {
            // Captura y registra cualquier error durante la creación
            console.error("Error al crear evento en agenda:", error);
            // Retorna un objeto con información del error
            return {
                error: true,
                mensaje:
                    error.message || "Error desconocido al crear evento en agenda",
            };
        }
    };
};


export const actualizarAgenda = (formData) => {

    // Retorna una función thunk (patrón de Redux Thunk para acciones asíncronas)
    return async (dispatch, getState) => {
        // Obtiene el ID del administrador desde el estado de autenticación
        const { id_admin } = getState().auth;

        try {
            // Llama al proveedor de API para crear un nuevo evento en la agenda
            const resultado = await actualizarAgendaApi({
                formData,
                id_admin_agenda: id_admin,
            });

            // Verificar si id_cliente no está vacío antes de ejecutar la inserción en bitácora
            if (formData.id_cliente && formData.id_cliente !== "") {
                await dispatch(
                    insertartBitacoraCliente({
                        bitacora_cliente: formData.id_cliente,
                        bitacora_nombreCliente: "Evento de agenda creado",
                        bitacora_detalle: `Se ha Editado un evento "${formData.nombre_agenda}" para las fechas ${formData.fecha_inicio_agenda} a ${formData.fecha_fin_agenda} en horario de ${formData.hora_inicio_agenda} a ${formData.hora_fin_agenda} de tipo ${formData.tipo_agenda}`,
                    }),
                );
            }

            // Retorna el resultado de la creación del evento
            return resultado;
        } catch (error) {
            // Captura y registra cualquier error durante la creación
            console.error("Error al crear evento en agenda:", error);
            // Retorna un objeto con información del error
            return {
                error: true,
                mensaje:
                    error.message || "Error desconocido al crear evento en agenda",
            };
        }
    };
};




export const traerEventosTodosPersonal = (estado_agenda, fecha_inicio, fecha_fin) => {
    // Retorna una función thunk (patrón de Redux Thunk para acciones asíncronas)
    return async (dispatch, getState) => {
        // Obtiene el ID del administrador desde el estado de autenticación
        const { id_admin } = getState().auth;

        try {
            // Llama al proveedor de API para obtener los eventos de agenda según los criterios especificados
            const resultado = await traerEventosTodosPersonalApi({
                estado_agenda,
                fecha_inicio,
                fecha_fin,
                id_admin_agenda: id_admin,
            });

            // Retorna los datos de eventos de agenda obtenidos
            return resultado;
        } catch (error) {
            // Captura y registra cualquier error durante la obtención de datos
            console.error("Error al obtener eventos de agenda:", error);
            // Se podría mejorar este manejo de errores lanzando una excepción o devolviendo un objeto de error
            return {
                error: true,
                mensaje:
                    error.message || "Error desconocido al obtener eventos de agenda",
            };
        }
    };
};


export const extraerEventoId = (id_agenda) => {
    // Retorna una función thunk (patrón de Redux Thunk para acciones asíncronas)
    return async (dispatch, getState) => {
        // Obtiene el ID del administrador desde el estado de autenticación
        const { id_admin } = getState().auth;

        try {
            // Llama al proveedor de API para obtener los eventos de agenda según los criterios especificados
            const resultado = await extraerEventoIdApi({
                id_agenda
            });

            // Retorna los datos de eventos de agenda obtenidos
            return resultado;
        } catch (error) {
            // Captura y registra cualquier error durante la obtención de datos
            console.error("Error al obtener eventos de agenda:", error);
            // Se podría mejorar este manejo de errores lanzando una excepción o devolviendo un objeto de error
            return {
                error: true,
                mensaje:
                    error.message || "Error desconocido al obtener eventos de agenda",
            };
        }
    };
};